import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { getSerendipityAction } from 'modules/serendipity/actions';
import { setBreadcrumb } from 'components/Navbar/modules';
import { resetAll } from 'modules/steps/actions';
import FineTune from '../components';

function mapStateToProps(state) {
  return {
    literals: state.i18n.literals.initiatives || {},
    element: state.elements.element,
    narratives: state.narratives.list,
    itemsPreferencesFromSerendipity: state.serendipity.preferences,
    user: state.session.user,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    getSerendipityAction: bindActionCreators(getSerendipityAction, dispatch),
    setBreadcrumb: bindActionCreators(setBreadcrumb, dispatch),
    resetAll: bindActionCreators(resetAll, dispatch),

  };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(FineTune));



// WEBPACK FOOTER //
// ./src/routes/FineTune/container/index.js